import React from 'react';
import Modal from 'react-bootstrap/Modal';
import withTranslations from '../../utils/HighOrderComponent';
import ButtonSave from '../Reusable/ButtonSave';
import { handleErrorMessage } from '../../utils';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';
import ErrorHandler from '../Reusable/ErrorHandler';
import { autonomousProvinces } from '../../constants/globals';

class ModalForAddPlaceToAutonomousProvince extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      autonomousProvince: null,
      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.handleClientValidation()) {
      return;
    }

    const placeForUpdate = {
      ...this.props.place,
      autonomousProvince: this.state.autonomousProvince,
    };

    this.props.updatePlace(placeForUpdate);
  };

  changeComboAutocompleteValue = (name, newValue) => {
    this.setState({
      autonomousProvince: newValue.value,
    });
  };

  render() {
    const { error, deleteError, t, enums, place } = this.props || {},
      { Placeholders, Labels } = t || {},
      { AutonomousProvince } = enums || [];

    const autonomousProvinceValue =
      autonomousProvinces[place?.autonomousProvince];

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={this.props.secondModal && 'secondModal'}
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <ErrorHandler error={error} deleteError={deleteError} />
            <h5 className="title mb-4">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12">
                <div className="form-group">
                  <ComboBoxAutocomplete
                    data={AutonomousProvince}
                    text={(autonomousProvince) => autonomousProvince.text}
                    changeValue={(newValue) =>
                      this.changeComboAutocompleteValue(
                        'autonomousProvince',
                        newValue
                      )
                    }
                    updateValue={autonomousProvinceValue}
                    wholeObject
                    placeholder={Placeholders.autonomousProvince}
                    error={handleErrorMessage(
                      error,
                      'autonomousProvince',
                      this.state.errors.autonomousProvince
                    )}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForAddPlaceToAutonomousProvince,
  'ModalForAddPlaceToAutonomousProvince'
);
